import { render, staticRenderFns } from "./ExamStatusBar.vue?vue&type=template&id=624f2e7c&scoped=true"
import script from "./ExamStatusBar.vue?vue&type=script&lang=js"
export * from "./ExamStatusBar.vue?vue&type=script&lang=js"
import style0 from "./ExamStatusBar.vue?vue&type=style&index=0&id=624f2e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f2e7c",
  null
  
)

export default component.exports